import Combat from './Combat';

export default Combat;
export { Combat };
